// extracted by mini-css-extract-plugin
export default {"dashboard-container":"Balance_dashboard-container__is0i8","dashboard-title":"Balance_dashboard-title__Xm6ip"};